export enum Renderer {
  SVG = 'svg',
  IMAGE = 'image',
  CANVAS = 'canvas',
}
